import { z } from 'zod';
export const StructuredTagSchema = z.object({
    name: z.string(),
    level: z.enum([
        'positive',
        'moderate',
        'negative'
    ]),
    correlatesTo: z.string().nullish(),
    // BAL-8159: concise reasoning per signal. Nullish here (unlike the prompt schemas) because this
    // is the admin/DB-facing shape and pre-feature reports in the DB have no reasoning at all — the
    // admin edit form must still parse them.
    reasoning: z.string().nullish()
});
export const UnstructuredTagSchema = z.object({
    name: z.string(),
    level: z.string(),
    // BAL-8159: concise reasoning per signal. Nullish here (unlike the prompt schemas) because this
    // is the admin/DB-facing shape and pre-feature reports in the DB have no reasoning at all — the
    // admin edit form must still parse them.
    reasoning: z.string().nullish()
});
export const TagsSchema = z.object({
    structured: z.array(StructuredTagSchema).nullish(),
    unstructured: z.array(UnstructuredTagSchema).nullish()
}).meta({
    id: 'Tags'
});

//# sourceMappingURL=tags.schema.js.map